<template>
  <div>
		<v-layout row wrap>
			<v-flex xs12>
				<p class="title-form">Filtro</p>
			</v-flex>
			<v-flex xs10>
				<v-layout row wrap align-center mb-3>
					<v-flex md5 my-1>
						<v-layout row wrap align-center class="calendar-range">
							<v-flex md6 pa-0>
								<v-menu 
								v-model="menu"
								transition="scale-transition"
								offset-y
								full-width
								class="menu-date-picker"
								:nudge-left="40"
								max-width="250px"
								v-on:input="changeIconStart"
								>
								<v-text-field
								slot="activator"
								label="Fecha inicial"
								class="product-date-picker"
								v-model="startDate"
								prepend-icon="event"
								:append-icon="arrowIconStart"
								:append-icon-cb="toggleIconStartDate"
								single-line
								hide-details
								readonly
							></v-text-field>
							<v-date-picker
								v-model="startDate"
								no-title
								scrollable>
								</v-date-picker>
								</v-menu>
							</v-flex>
							<v-flex md6 pa-0>
								<v-menu
								lazy
								v-model="menuEnd"
								transition="scale-transition"
								offset-y
								full-width
								class="menu-date-picker"
								:nudge-left="40"
								max-width="290px"
								v-on:input="changeEndIcon"
								>
								<v-text-field
									slot="activator"
									label="Fecha final"
									v-model="endDate"
									:append-icon="arrowIconEnd"
									:append-icon-cb="toggleIconEndDate"
									single-line
									hide-details
									readonly
									></v-text-field>
									<v-date-picker
									v-model="endDate"
									no-title
									scrollable>
									</v-date-picker>
								</v-menu>
							</v-flex>
						</v-layout>
					</v-flex>
					<v-flex md1 pr5>
					<v-btn
					type="button"
					class="btn-action btn-success white--text"
					:disabled="!startDate || !endDate"
					@click="filterBookings">
					<v-icon>filter_list</v-icon>
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs2 mt-2>
				<v-btn
				class="btn-action btn-success white--text"
				@click="printGuest">
					<v-icon>print</v-icon>
					Imprimir Listado
				</v-btn>						
			</v-flex>
			<v-flex xs12 mt5>
				<table-run
				class="no-selectable-table"
				:selectable="false"
				:include-delete="false"
				:include-export-to-excel="false"
				:include-options="true"
				:include-switch="false"
				:include-settings="true"
				:include-delete-single="false"
				:columns="columns"
				:option-buttons="optionButtons"
				@custom-button="customButton"
				@on-search-event="searchByColumn"
				@go-to-edit-page="goToEdit"
				:rows="rows"
				@on-sortable-event="columnSortableEvent">
				<template slot="rows" scope="props">
					<td>{{props.row.numReservation}}</td>
					<td>{{props.row.bookingStart}}</td>
					<td>
					{{ props.row.codeRoomtype }}
					</td>
					<td>{{props.row.bookingStart}}</td>
					<td>{{props.row.bookingEnd}}</td>
					<td>{{props.row.total}}</td>
					<td>{{props.row.totalConsumptions}}</td>
				</template>
				</table-run>
				<v-flex xs12 text-xs-right>
					<v-pagination
					v-bind:length="totalHistoryPages"
					v-model="paramsBookingHistory.page"
					:total-visible="pagesVisibleHistory"
					v-on:input="loadBookingHistory(paramsBookingHistory.page)"
					></v-pagination>
				</v-flex>	
			</v-flex>
			<v-layout row wrap justify-center mt-4>
				<v-flex xs2>
				<v-btn
				type="button"
				class="btn-action btn-success white--text"
				@click="returnGuest"
				>
				Volver
				</v-btn>
			</v-flex>
			</v-layout>
		</v-layout>
		<modal-history-guest v-if="visibleModal"
			:booking-code="modalHistory.code"
			@close="closeModal"></modal-history-guest>
	</div>
</template>

<script>
import tableRun from 'table-run';
import mixin from '@/shared/mixins';
import modalHistoryGuest from '@/clerkinn/guest/modal-history-guest';
import helper from '@/shared/helper';

const helperMethods = helper.methods;

async function printGuest() {
	const baseUrl = `${process.env.PMS_URL}/report/customerBooking`;
	const customerId = this.paramsBookingHistory.idCustomer;
	const dateStart = this.startDate;
	const dateEnd = this.endDate;
	const name = 'Reporte Historial del Huesped';
	const responseType = 'blob';
	const cardModel = { rows: [{}] };
	const response = await this.$http.post(`${baseUrl}?customerId=${customerId}&dateStart=${dateStart}&dateEnd=${dateEnd}`, cardModel, { responseType });
	const blob = helperMethods.generateBlob(response.bodyBlob);
	helperMethods.showDownloadDialog(blob, name, 'pdf');
}

function closeModal() {
	this.visibleModal = false;
}

function goToEdit(action) {
	const editHref = {
		name: 'detail-guest',
		query: { codeBooking: action.code },
	};
	this.$router.push(editHref);
}

function returnGuest() {
	const editHref = { name: 'guest' };
	this.$router.push(editHref);
}
function searchByColumn(search) {
	this.paramsBookingHistory.search = search;
	this.loadBookingHistory();
}

function columnSortableEvent({ id }) {
	const self = this;
	const newColumn = self.columns.filter(column => column.id === id);
	newColumn[0].isSortable = newColumn[0].isSortable.down ?
		{ down: false, up: true } : { down: true, up: false };
	self.columns = self.columns.map((columnSingle) => {
		const newColumnSingle = Object.assign({}, columnSingle);
		if (columnSingle.isSortable) {
			if (columnSingle.id !== newColumn[0].id) {
				newColumnSingle.isSortable = { down: true, up: false };
			}
		}
		return newColumnSingle;
	});
	this.paramsBookingHistory.sortField = newColumn[0].code;
	this.paramsBookingHistory.sortDirection = newColumn[0].isSortable.up ? 'asc' : 'desc';
	this.loadBookingHistory();
}

function created() {
	this.loadBookingHistory();
}

function customButton({ btn, row }) {
	if (btn.id === 3) {
		this.modalHistory = row;
		this.visibleModal = true;
	}
}


function pagesVisibleHistory() {
	if (this.totalHistoryPages >= 1 && this.totalHistoryPages < 5) {
		return this.totalHistoryPages;
	}
	return 5;
}

async function loadBookingHistory(page = 1) {
	this.paramsBookingHistory.page = page;
	this.paramsBookingHistory.idCustomer = this.$route.query.customerId;
	const response = await this.$http.get(`${process.env.PMS_URL}/customer/bookings`, { params: this.paramsBookingHistory });
	this.totalHistoryPages = response.data.meta.pagination.total_pages;
	this.isLoading = true;
	this.rows = response.data.data.map((row) => {
		const newRow = Object.assign({}, row);
		if (row.summary && row.summary.booking) {
			newRow.guests = row.summary.booking.adults + row.summary.booking.childrens;
		}
		return newRow;
	});
}

function filterBookings() {
	this.paramsBookingHistory.dateInit = this.startDate;
	this.paramsBookingHistory.dateEnd = this.endDate;
	this.loadBookingHistory();
}

function arrowIconEnd() {
	const arrowEnd = this.onChangeEnd ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowEnd;
}

function toggleIconEndDate() {
	this.onChangeEnd = !this.endDate;
}

function changeEndIcon(result) {
	this.onChangeEnd = result;
}

function arrowIconStart() {
	const arrowStart = this.onChangeStart ? 'arrow_drop_up' : 'arrow_drop_down';
	return arrowStart;
}

function toggleIconStartDate() {
	this.onChangeStart = !this.startDate;
}

function changeIconStart(result) {
	this.onChangeStart = result;
}

function data() {
	return {
		customerId: 0,
		id: null,
		visibleModal: false,
		modalHistory: {},
		isLoading: false,
		totalHistoryPages: 5,
		paramsBookingHistory: {
			page: 1,
			perPage: 10,
			idCustomer: null,
		},
		optionButtons: [
			{
				id: 3,
				icon: 'remove_red_eye',
				code: 'remove_red_eye',
			},
		],
		columns: [
			{ id: 1, name: '#Reserva', code: 'number' },
			{ id: 2, name: 'Fecha de Reserva', code: 'date-reservation' },
			{ id: 3, name: 'Habitación', code: 'room' },
			{ id: 4, name: 'Check In', code: 'check-in' },
			{ id: 5, name: 'Check Out', code: 'check-out' },
			{ id: 6, name: 'Gasto Total', code: 'total-cost' },
			{ id: 7, name: 'Gasto por Consumo', code: 'total-consum' },
		],
		rows: [],
		paramsBookin: {
			page: 1,
			perPage: 10,
			idCustomer: null,
		},
		startDate: '',
		menu: false,
		menuEnd: false,
		onChangeEnd: false,
		onChangeStart: false,
		endDate: '',
	};
}

export default {
	name: 'history-guest',
	data,
	created,
	components: {
		tableRun,
		modalHistoryGuest,
	},
	methods: {
		printGuest,
		closeModal,
		goToEdit,
		returnGuest,
		searchByColumn,
		customButton,
		columnSortableEvent,
		loadBookingHistory,
		filterBookings,
		changeEndIcon,
		changeIconStart,
		toggleIconStartDate,
		toggleIconEndDate,
	},
	computed: {
		pagesVisibleHistory,
		arrowIconEnd,
		arrowIconStart,
	},
	mixins: mixin,
};
</script>



// WEBPACK FOOTER //
// history-guest.vue?0e9ccd65